import { ref, Ref } from '@vue/composition-api';
import { CurrentUserStore } from './currentUser';

/**
 * The application bootstrap manager. Determines when the application is ready
 * to render.
 */
export interface BootstrapStore {
	isBootstrapComplete: Ref<boolean>;
	/**
	 * Starts the bootstrapping sequence. The value is cached so it only runs once.
	 */
	bootstrap: () => Promise<void>;
}

export function getBootstrapStore(userStore: CurrentUserStore): BootstrapStore {
	const requests = [
		() => userStore.actions.bootstrapUser(),
	];
	const isBootstrapComplete = ref(false);
	let bootstrapPromise: null | Promise<void> = null;
	function bootstrap(): Promise<void> {
		if (bootstrapPromise === null) {
			bootstrapPromise = Promise.all(requests.map((fn) => fn()))
				.then(() => {
					isBootstrapComplete.value = true;
				});
		}
		return bootstrapPromise;
	}
	return {
		isBootstrapComplete,
		bootstrap,
	};
}
